module.exports = __webpack_public_path__ + "img/holiday-days.b73e0977.svg";